import { Box, TableCell } from '@mui/material'
import React from 'react'
import { useResponsiveTypography } from '../../../../utility/responsiveTypography'

const TableCellList = ({ color, isHidden, value, width }) => {
  const { previewText } = useResponsiveTypography()
  return (
    <TableCell
      sx={{
        width: width + 'rem',
        color: color,
        display: isHidden ? 'none' : '',
        fontSize: previewText,
      }}
    >
      <Box
        sx={{
          overflow: 'auto',
        }}
      >
        {value}
      </Box>
    </TableCell>
  )
}

export default TableCellList
